import { useContext, useState } from "react";
import { InboxContext } from "./InboxTableProvider";
import { InboxList } from "./InboxList";
import InboxListContext from "./InboxListContext";
import { InboxSidebar } from "./InboxSidebar";
import AgentMonitor from "./agentMonitor/AgentMonitor";
import CompanyService from "../../services/CompanyService";

export const InboxTabContent = () => {
  const { request } = useContext(InboxContext);
  const { setMessageAll, setMessageIds } = useContext(InboxListContext);
  const [selectedFolder, setSelectedFolder] = useState<string>("received");

  const handleFolderChange = (folder: string) => {
    setSelectedFolder(folder);
    setMessageIds([]);
    setMessageAll(false);
  };

  const isAdmin = CompanyService.canMonitorAgents();
  const hasChatbotEnabled = CompanyService.getSetting("allowwhatsappchatbot");
  const showMonitor =
    selectedFolder === "monitor" && isAdmin && hasChatbotEnabled;

  return (
    <div className="d-flex" style={{ minHeight: 0, flex: 1 }}>
      <InboxSidebar
        onFolderChange={handleFolderChange}
        selectedFolder={selectedFolder}
      />
      {showMonitor ? (
        <AgentMonitor />
      ) : (
        <InboxList quickfilter={request.quickfilter} />
      )}
    </div>
  );
};

export const Counter = ({ counter }: { counter: number }) => {
  return <div className="counter-container">{counter}</div>;
};
